import React from "react";
import { VariantProps } from "..";
import MapOverride from "./MapOverride";
import Registered from "../Registered";
const M = ({
  user,
  selectedProduct,
  productListingView,
  setIsQuantityDiscountPopoverOpen
}: VariantProps) => {
  return user.registered && (selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers || selectedProduct.showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers) ? <Registered {...{
    user,
    selectedProduct,
    setIsQuantityDiscountPopoverOpen
  }} data-sentry-element="Registered" data-sentry-component="M" data-sentry-source-file="index.tsx" /> : <div className="map map-override mapM" data-sentry-component="M" data-sentry-source-file="index.tsx">
      <MapOverride productListingView={productListingView} enabled={selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers} data-sentry-element="MapOverride" data-sentry-source-file="index.tsx" />
    </div>;
};
export default M;